<template>
  <resource-base
      :ref="resourceBaseRef"
      :loading-display="false"
      :is-management-mode="isManagementMode"
      :display-activity="myAppSettings_isDisplayActivity"
      :display-settings="myAppSettings_isDisplaySettings"
      :resource="resource"
      :settings="settings"
      @appLog="appLog"
      @settings-gen-changed="handleSettingsGenChange"
      @update-settings="handleUpdateSettings"
  >
    <template v-slot:display>
      <b-container>
        <display
            :resource="resource"
            :settings="settings"
            :user-data="userData"
            @user-clicked-about="handleUserClickedAbout"
            @appLog="appLog"
        />
      </b-container>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings
          :resource="resource"
          :settings="settings"
          @resource-updated="handleRefreshResource"
          @update-user-data="handleUpdateUserData"
      />
    </template>
  </resource-base>
</template>

<script>
import ResourceBase from "../resourceBase";
import ResourceBlockIndex from "@/mixins/resourceBlocks/Index";
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
import optionsJSON from "./assets/json/optionsJSON.json";
export default {
  name: "Resource_PhotoAlbum",
  mixins: [ResourceBlockIndex],
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  created() {
    if (this.myAppSettings_isDisplaySettings ||
        this.myAppSettings_isDisplayActivity)
    { //Do not display BG if wither Settings or Activity is available
      this.appSetUp.useStyleClass = "none"
    }
    this.handleSetUp();
  },
  mounted() {},
  computed: {
  },
  methods: {
    handleRefreshResource() {
      this.$emit("refresh-publishing");
    },
    showResource() {
      this.show = true;
    },
    appLog(data) {
      //Use Mixins
      this.$emit("appLog", data);
    }
  },
  data() {
    return {
      optionsJSON,
      appSetUp: {
        useStyleClass: 'none',
        bgImgURL:
          "https://images.unsplash.com/photo-1502987846294-e7ec70f4b393?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1373&q=80"
      },
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}
</style>
